import useAlertStore from "@/store/use-alert-store";
import useAppStore from "@/store/use-app-store";
import {
  BarcodeReader,
  Inventory,
  MoveDown,
  NoteAdd,
  Warehouse,
} from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { Timer } from "components/Timer";
import Certificate from "components/crypto-pro/Certificate";
import CustomSystemInfo from "components/crypto-pro/CustomSystemInfo";
import Hash from "components/crypto-pro/Hash";
import Message from "components/crypto-pro/Message";
import Signature from "components/crypto-pro/Signature";
import SignatureType from "components/crypto-pro/SignatureType";
import SystemInfo from "components/crypto-pro/SystemInfo";
import { ExtPutEncodedDataMutation } from "components/gql/mutations/PutEncodedData";
import {
  createAttachedSignature,
  createDetachedSignature,
  createHash,
} from "crypto-pro";
import { isIdentical, isObjectEmpty } from "data/functions";

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export function MainBody(props) {
  const [message, setMessage] = useState("");
  const [dataUuid, setDataUuid] = useState("");
  const [companyUuid, setCompanyUuid] = useState("");
  const [certificate, setCertificate] = useState(null);
  // const [detachedSignature, setSignatureType] = useState(null);
  const [hash, setHash] = useState("");
  const [hashStatus, setHashStatus] = useState("Не вычислен");
  const [hashError, setHashError] = useState(null);
  const [signature, setSignature] = useState("");
  const [signatureStatus, setSignatureStatus] = useState("Не создана");
  const [signatureError, setSignatureError] = useState(null);
  const [putDataMutation] = ExtPutEncodedDataMutation();
  const [disableButton, setDisableButton] = useState(false);

  const { setAlert } = useAlertStore();

  async function createSignature(event) {
    let hash;
    event.preventDefault();

    setSignature("");
    setSignatureError(null);

    setHash("");
    setHashError(null);
    setHashStatus("Вычисляется...");

    try {
      hash = await createHash(message);
      setHash(hash);
    } catch (error) {
      setAlert(error?.message, "error");
      return;
    }

    setHashStatus("Не вычислен");
    setSignatureStatus("Создается...");

    // if (detachedSignature) {
    //   try {
    //     setSignature(
    //       await createDetachedSignature(certificate.thumbprint, hash),
    //     );
    //   } catch (error) {
    //     setAlert(error?.message, "error");
    //   }

    //   setSignatureStatus("Не создана");

    //   return;
    // }

    let typeSignature = (
      useAppStore.getState()?.message?.signature_type || "attached"
    ).toLowerCase();

    try {
      let sign =
        typeSignature === "attached"
          ? await createAttachedSignature(certificate.thumbprint, message)
          : await createDetachedSignature(certificate.thumbprint, hash);
      let { data, error } = await putDataMutation({
        variables: {
          input: {
            companyUuid:
              companyUuid || useAppStore.getState()?.companyUuid || "",
            dataUuid: dataUuid,
            encodedData: sign,
          },
        },
      });
      if (data) {
        if (data?.mrkcd_PutEncodedData?.success === true) {
          setAlert("Подпись сохранена.", "success");
        } else {
          setAlert("Что-то пошло не так.", "warning");
        }
      }
      if (error) {
        setAlert(error?.message, "error");
      }
      setSignature(sign);
      setSignatureStatus("Создана");
      return;
    } catch (error) {
      setAlert(error?.message, "error");
      setSignatureError(error.message);
    }
    setSignatureStatus("Не создана");
  }
  useEffect(() => {
    if (!isObjectEmpty(signatureError) || !isObjectEmpty(signature)) {
      setTimeout(() => {
        setSignature("");
        setSignatureError(null);
      }, 10000);
    }
  }, [signatureError, signature]);

  useEffect(() => {
    if (
      !isObjectEmpty(certificate?.thumbprint) &&
      !isIdentical(
        certificate?.thumbprint,
        useAppStore.getState()?.certificateThumbprint,
      )
    ) {
      useAppStore.setState({ certificateThumbprint: certificate?.thumbprint });
    }
  }, [certificate?.thumbprint]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          gap: "6px",
          minWidth: "50%",
          padding: "12px",
        }}
      >
        <Box>
          <Typography variant="h4">Создание подписи</Typography>
          <Message
            onChange={setMessage}
            setCompanyUuid={setCompanyUuid}
            setDataUuid={setDataUuid}
          />

          <Certificate onChange={setCertificate} />

          {/* <SignatureType onChange={setSignatureType} /> */}
        </Box>
        <TimerBlock
          disableButton={disableButton}
          setDisableButton={setDisableButton}
        />
        <Button
          color="inherit"
          disabled={!certificate || !message || disableButton}
          onClick={(e) => createSignature(e)}
          variant="outlined"
        >
          Создать подпись
        </Button>
        <Box
          sx={{ visibility: isObjectEmpty(signature) ? "hidden" : "visible" }}
        >
          {/* <Hash hash={hash} hashError={hashError} hashStatus={hashStatus} /> */}

          <Signature
            signature={signature}
            signatureError={signatureError}
            signatureStatus={signatureStatus}
          />
        </Box>
      </Box>
    </>
  );
}

function TimerBlock(options = {}) {
  const { disableButton, setDisableButton } = options;
  const { message } = useAppStore();

  const [remainingTime, setRemainingTime] = useState();
  const [timerCount, setTimerCount] = useState();
  useEffect(() => {
    if (isObjectEmpty(message?.date)) return;
    try {
      setTimerCount(new Date(message?.date));
    } catch (error) {}
  }, [message]);

  useEffect(() => {
    if (isObjectEmpty(message?.date)) {
      setDisableButton(false);
      return;
    }

    const disable = remainingTime === 0;
    if (!isIdentical(disableButton, disable)) {
      setDisableButton(disable);
    }
  }, [remainingTime, message?.date]);

  return (
    <Box
      sx={{
        display: isObjectEmpty(message?.date) ? "none" : undefined,
        paddingTop: "1rem",
      }}
    >
      <Timer
        expiryTimestamp={timerCount}
        remainingTime={remainingTime}
        setRemainingTime={setRemainingTime}
        variant="url"
      />
    </Box>
  );
}
